module.exports = __webpack_public_path__ + "img/couples-020.8ec41f3f.jpg";